import React from "react";
import CreatorCard from "./CreatorCard";

const Creator = () =>{

    const cardItems = [1,2,3,4,5,6,7,8,9,10,11,12];

    return(
        <>
            <div className="_creator_top_wrap">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="_creator_title_wrap">
                        <h2 className="_creator_title">Creators</h2>
                        <p className="_creator_txt">Welcome AllBlocks Creators page</p>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="_creator_top_right">
                        <div className="btn-group _creator_top_right_btn_wrap">
                            <button className="btn dropdown-toggle _creator_top_right_btn" type="button"
                                id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true"
                                aria-expanded="false">
                                Featured
                            </button>
                            <ul className="dropdown-menu _creator_top_btn_drop" aria-labelledby="defaultDropdown">
                                <li><a className="dropdown-item _creator_top_btn_drop_item" href="#0">Best selling</a></li>
                                <li><a className="dropdown-item _creator_top_btn_drop_item" href="#0">Popular items</a></li>
                                <li><a className="dropdown-item _creator_top_btn_drop_item" href="#0">New items</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="_creator_mid_wrap">
                <div className="row">
                    {
                        cardItems.map((card,id) => {
                            return <CreatorCard key={id}/>
                        })
                    }
                </div>
            </div>
        </div>
    </div>
        </>
    )
}
export default Creator;